import { Box, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";

import { UpsellForm } from "../../../../store/api/upsellApi";

export default function UpsellFinishStep({ upsell }: { upsell: UpsellForm }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <DialogTitle>New upsell overview</DialogTitle>
      <DialogContent>
        Will create a new upsell <Typography component={"b"}>{upsell.name}</Typography>
      </DialogContent>
    </Box>
  );
}
